export default __webpack_public_path__ + "static/poster-5-ac33f60ab1e48757cd9036e49f34f4c1.webm";